import AutomationCommon from "../common";
import AutomationBlockTypes from "../../AutomationBlockTypes";

const vt = AutomationCommon.vt;
const contexts = AutomationCommon.contexts;
const ga = AutomationCommon.ga;

class CreateTaskAttributeFactory {
    constructor(parent) {
        this.parent = parent;
    }

    generate(prefix, block) {
        if (block.type !== AutomationBlockTypes.CREATE_TASK) {
            console.warn(`CreateTaskAttributeFactory not supported for ${block.type}`);
            return [];
        }

        return [
            ga(contexts.BLOCK, `${prefix}.$..*`, "*", vt.OBJECT),
            ga(contexts.BLOCK, `${prefix}.success`, "Success", vt.BOOLEAN),
            ga(contexts.BLOCK, `${prefix}.taskId`, "Task ID", vt.STRING)
        ];
    }
}

export default CreateTaskAttributeFactory;
